import { render, staticRenderFns } from "./SystemVISettings.vue?vue&type=template&id=2119d56a&scoped=true&"
import script from "./SystemVISettings.vue?vue&type=script&lang=js&"
export * from "./SystemVISettings.vue?vue&type=script&lang=js&"
import style0 from "./SystemVISettings.vue?vue&type=style&index=0&id=2119d56a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2119d56a",
  null
  
)

export default component.exports